/* eslint-disable react/prop-types */
import { Box, Card, Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import Palette from '../../theme/palette';
import Addemail from '../../components/email/Addemail';

const Overview = ({ data, setUserAction }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {/* Add Email Model */}
      <Addemail open={open} handleClose={handleClose} _id={data?._id} receiver={data} setUserAction={setUserAction} />

      <Card style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
        <Box p={3}>
          <Grid container display="flex" spacing={4}>
            <Grid item xs={12} sm={6}>
              <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                <Typography variant="body1">Name :</Typography>
                <Typography variant="body2" color={Palette.grey[600]} textTransform={"capitalize"}>{`${data?.['4000']} ${data?.['4002']}`}</Typography>
              </Grid>
              <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                <Typography variant="body1">Date Of Birth :</Typography>
                <Typography variant="body2" color={Palette.grey[600]}>
                  {data?.['1402'] ? dayjs(data?.['1402']).format("DD/MM/YYYY") : "null"}
                </Typography>
              </Grid>
              <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                <Typography variant="body1">Marital Status :</Typography>
                <Typography variant="body2" color={Palette.grey[600]}>{data?.['52'] ? data?.['52'] : "null"}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
            <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                <Typography variant="body1">Email :</Typography>
                <Typography variant="body2" color={Palette.primary.main} onClick={handleOpen} style={{ cursor: "pointer" }}>{data?.['1240'] ? data?.['1240'] : "null"}</Typography>
              </Grid>
              <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                <Typography variant="body1">Phone Number :</Typography>
                <Typography variant="body2" color={Palette.grey[600]}>{data?.['66'] ? data?.['66'] : "null"}</Typography>
              </Grid>
              <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                <Typography variant="body1">Accept Text :</Typography>
                <Typography variant="body2" color={Palette.grey[600]}>{data?.['4920'] ? data?.['4920'] : "No"}</Typography>
              </Grid>
            </Grid>
            {/* Current Address Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Current Address
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                    <Typography variant="body1">Current Street Address :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0126 ? data?.fr0126 : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Current City :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0106 ? data?.fr0106 : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Current State :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0107 ? data?.fr0107 : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Current Zip :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0108 ? data?.fr0108 : "null"}</Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                    <Typography variant="body1">How Long at Address (Years) :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0112 ? data?.fr0112 : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">How Long at Address (Months) :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0124 ? data?.fr0124 : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Housing :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr0115 ? data?.fr0115 : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Housing Payment :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.fr01115 ? data?.fr01115 : "null"}</Typography>
                  </Grid>
                </Grid>
                
              </Grid>
            </Grid>
            {/* Loan Information Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Loan Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Estimated Value :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["1821"] ? data?.["1821"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Subject Property Address :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.urla?.x73 ? data?.urla?.x73 : "null"}</Typography>
                  </Grid>
                  
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">City :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["12"] ? data?.["12"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">State :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["14"] ? data?.["14"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Zip :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["15"] ? data?.["15"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Rate :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["3"] ? data?.["3"] : "null"}</Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Purpose of Loan :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["19"] ? data?.["19"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Property Will Be :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["1811"] ? data?.["1811"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Loan Type :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["1172"] ? data?.["1172"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Purchase Price :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["136"] ? data?.["136"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Down Payment Amount :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["1335"] ? data?.["1335"] : "null"}</Typography>
                  </Grid>
                
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Term :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["4"] ? data?.["4"] : "null"}</Typography>
                  </Grid>
                  <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1">Total Monthly Payment :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.["912"] ? data?.["912"] : "null"}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </div>
  );
};

export default Overview;
